module.exports = __webpack_public_path__ + "static/img/pay_qrpay_wechatpay2@3x.668d3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_wechatpay2@3x.png
// module id = YyzO
// module chunks = 1